// extracted by mini-css-extract-plugin
export default {"hideTooltip":"gaa-z","fadeIn":"haa-z","delay":"iaa-z","recommendedSizeTooltip":"jaa-z"};